import { getDiscount, getItemCategory, getItemCategory2, normalizeBrand } from '../../utils';

export async function itemsFromList(context: Record<string, any>) {
  const { item } = context;

  return [
    {
      price: item?.price.list || item?.price || 0,
      quantity: 1,
      item_ref: context.item.ref || context.item.additionalProperty.find((i: { name: string }) => i.name === "RefId").value || null,
      index: typeof context?.index === 'number' ? context.index : null,
      item_brand: normalizeBrand(item.brand.name) || normalizeBrand(context.brand) || null,
      item_name: item.productName || item.alternateName || null,
      item_category: getItemCategory(item) || null,
      item_variant: item?.name?.split("-")[0].trim() || null,
      item_category2:  getItemCategory2(item) || item?.category?.split(">")[1]?.trim() || null,
      item_id: item?.productID || item?.productId || null,
      discount: getDiscount(item) || null,
      item_list_name: context?.itemListName || null,
    },
  ];
}
